import {
  CameraIcon,
  CloudArrowUpIcon,
  PencilSquareIcon,
} from "@heroicons/react/24/outline";
import {
  BriefcaseIcon,
  EyeIcon,
  IdentificationIcon,
} from "@heroicons/react/24/solid";

const features = [
  {
    name: "Publicación",
    description:
      "Publicamos su auto en moviautos.com en la sección Collection by Movi donde tendrá la mayor visibilidad. Su auto aparecerá en nuestro catálogo en Facebook e Instagram y lo compartiremos con nuestra red de contactos estratégicos.",
    href: "#",
    icon: CloudArrowUpIcon,
  },
  {
    name: "Contenido y mercadeo",
    description:
      "Las mejores fotos y videos, que compartiremos y promoveremos en nuestras redes sociales.",
    href: "#",
    icon: CameraIcon,
  },
  {
    name: "Filtro de clientes",
    description:
      "Filtramos a las personas interesadas y nos aseguramos que sean personas serias y de confianza.",
    href: "#",
    icon: IdentificationIcon,
  },
  {
    name: "Citas",
    description:
      "Nos encargamos de analizar, filtrar y agendar las citas con las personas interesadas.",
    href: "#",
    icon: EyeIcon,
  },
  {
    name: "Asesoría",
    description:
      "Le ofrecemos asesoría especializada y le conectamos con servicios financieros, de seguros y post-venta relacionados al mercado automotríz.",
    href: "#",
    icon: BriefcaseIcon,
  },
  {
    name: "Traspaso",
    description: "Le asesoramos y le ofrecemos el servicio de traspaso.",
    href: "#",
    icon: PencilSquareIcon,
  },
];

export default function CollectionServices() {
  return (
    <div className="bg-white py-8">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-2xl lg:mx-0">
          <h2 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
            Servicios que ofrecemos
          </h2>
          <p className="mt-6 text-lg leading-8 text-gray-600">
            Te ofrecemos servicios especializados con el objetivo de vender tu
            auto de la forma más fácil, discreta y segura.
          </p>
        </div>
        <div className="mx-auto mt-8 max-w-2xl lg:max-w-none">
          <dl className="grid max-w-xl grid-cols-1 gap-x-8 gap-y-16 lg:max-w-none lg:grid-cols-3">
            {features.map((feature) => (
              <div key={feature.name} className="flex flex-col">
                <dt className="text-base font-semibold leading-7 text-gray-900">
                  <div className="mb-6 flex h-10 w-10 items-center justify-center rounded-lg bg-orange-500">
                    <feature.icon
                      className="h-6 w-6 text-white"
                      aria-hidden="true"
                    />
                  </div>
                  {feature.name}
                </dt>
                <dd className="mt-1 flex flex-auto flex-col text-base leading-7 text-gray-600">
                  <p className="flex-auto">{feature.description}</p>
                </dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </div>
  );
}
